// extracted by mini-css-extract-plugin
module.exports = {"sectionFour":"SectionFour_sectionFour__LKI0V"};